import { createReducer } from '@reduxjs/toolkit';
import {
	fetchFieldMetadataAction,
	fetchFieldMetadataResolved,
	fetchFieldMetadataRejected,
	clearFieldMetadataAction,
} from '@Actions/rehab.actions';
import { RehabStoreState, ConditionScore, EventType, TaskType } from '@Types/rehab.types';

export const initialState: RehabStoreState = {
	isLoading: false,
	eventTypes: [],
	taskTypes: [],
	conditionScores: [],
};

const rehabReducer = createReducer(initialState, builder => {
	builder
		.addCase(fetchFieldMetadataAction, state => {
			state.isLoading = true;
		})
		.addCase(fetchFieldMetadataResolved, (state, action) => {
			state.isLoading = false;
			if (action.payload.type === 'events') {
				state.eventTypes = action.payload.data as EventType[];
			} else if (action.payload.type === 'tasks') {
				state.taskTypes = action.payload.data as TaskType[];
			} else if (action.payload.type === 'condition') {
				state.conditionScores = action.payload.data as ConditionScore[];
			}
		})
		.addCase(fetchFieldMetadataRejected, state => {
			state.isLoading = false;
		})
		.addCase(clearFieldMetadataAction, state => {
			state.eventTypes = [];
			state.taskTypes = [];
		});
});

export default rehabReducer;
